import { render } from "./SidebarList.vue?vue&type=template&id=2d03e87a&scoped=true"
import script from "./SidebarList.vue?vue&type=script&lang=js"
export * from "./SidebarList.vue?vue&type=script&lang=js"

import "./SidebarList.vue?vue&type=style&index=0&id=2d03e87a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d03e87a"]])

export default __exports__